import type { GriffelStyle } from '@fluentui/react-components';

/**
 * Control del header — el MISMO para el chip de créditos, la píldora del plan, el carrito,
 * el tema, la empresa y el botón de 9 puntos. Lenguaje del hub del cliente
 * (opus.com.mx/public: `.theme-btn`, chip de créditos): rectángulo de radio 8px con borde
 * fino de 1px y fondo sutil, todos del mismo alto (38px). Tokens en el design system
 * (`--control-*`, `--radius-control`); OPUS bi usa los mismos en `.opus-ctrl`.
 */
export const controlDelHeader: GriffelStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '7px',
  height: 'var(--control-h)',
  minWidth: 'var(--control-h)',
  padding: '0 12px',
  boxSizing: 'border-box',
  border: '1px solid var(--control-border)',
  borderRadius: 'var(--radius-control)',
  background: 'var(--control-bg)',
  color: 'var(--text-primary)',
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
  cursor: 'pointer',
  flexShrink: 0,
  transitionProperty: 'background, border-color, color',
  transitionDuration: '120ms',
  ':hover': {
    background: 'var(--control-bg-hover)',
    border: '1px solid var(--control-border-hover)',
  },
  ':focus-visible': { outline: '2px solid var(--accent)', outlineOffset: '2px' },
};

/** Variante cuadrada solo con ícono (carrito, tema, 9 puntos): 38×38. */
export const controlIcono: GriffelStyle = {
  ...controlDelHeader,
  width: 'var(--control-h)',
  padding: 0,
  color: 'var(--text-secondary)',
  ':hover': {
    background: 'var(--control-bg-hover)',
    border: '1px solid var(--control-border-hover)',
    color: 'var(--text-primary)',
  },
};
